import React, { useEffect } from "react";
import classnames from "classnames";
import styles from "./Toast.module.scss";

/** Сколько тост висит на экране, мс */
export const TOAST_DURATION_MS = 3500;

export interface ToastProps {
    /** Текст; пусто — тоста нет */
    text: string;
    /** Меняется с каждым тостом: тот же текст подряд показывается заново и таймер идёт сначала */
    toastKey?: number;
    /** Тост истёк */
    onDismiss?: () => void;
    duration?: number;
    /** Без привязки к низу экрана — для витрины */
    inline?: boolean;
}

/**
 * Короткое сообщение о результате действия: внизу над вкладками, исчезает само.
 * Подтверждение в нём не просят — оно нужно только для необратимых действий.
 */
export const Toast = ({ text, toastKey, onDismiss, duration = TOAST_DURATION_MS, inline }: ToastProps) => {
    useEffect(() => {
        if (!text || !onDismiss) {
            return undefined;
        }

        const timer = window.setTimeout(onDismiss, duration);

        return () => window.clearTimeout(timer);
    }, [text, toastKey, duration, onDismiss]);

    if (!text) {
        return null;
    }

    return (
        <div className={classnames(styles.wrap, { [styles.inline]: inline })}>
            <div className={styles.toast} role="status" aria-live="polite">
                {text}
            </div>
        </div>
    );
};
